// JavaScript file for HL
export const channelCode = 'HL';
